<template>
    <NuxtLink v-slot="{href, navigate}" to="/resources/search" custom>
        <VJoyButton
            :circle="isGhostIconButton"
            :variant="isGhostIconButton ? 'ghost' : 'secondary'"
            :class="{'rc-search-cta': true, [buttonClass ?? '']: !!buttonClass}"
            icon="search"
            :href="href"
            size="small"
            @click="navigate"
        >
            <span v-show="!isGhostIconButton" class="message">{{ message }}</span>
        </VJoyButton>
    </NuxtLink>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {useMediaQuery} from '@malt/utils';
    import {VJoyButton} from '@maltjoy/core-vue';

    defineProps<{message: string; buttonClass?: string}>();

    const {matchMedia} = useMediaQuery();
    const isGhostIconButton = computed(() => (matchMedia.value.max.Sm || matchMedia.value.min.Md) && !matchMedia.value.min.Lg);
</script>

<style lang="scss">
    .rc-search-cta {
        padding: var(--joy-core-spacing-2) var(--joy-core-spacing-5) var(--joy-core-spacing-2) var(--joy-core-spacing-5) !important;

        .icon-search {
            position: relative;
            top: 2px;
        }
    }
</style>
